import { generatePath } from 'react-router'

import { env, routes } from '~config'
import { isSponsorOrReferent, isYoung } from '~helpers'

type NavMenuItem = {
  link: string
  icon: string
  label: string
  badge?: string
}

export const getNavMenu = ({
  matchings,
  user,
}: {
  matchings?: Matchings[]
  user?: User
}): NavMenuItem[] | undefined => {
  if (!user) return

  const isMentor = isSponsorOrReferent(user)

  const baseItems: NavMenuItem[] = [
    {
      link: routes.authenticated.home,
      icon: 'house',
      label: 'Accueil',
    },
    {
      link: routes.authenticated.events,
      icon: 'calendar',
      label: 'Évènements',
    },
    {
      link: routes.authenticated.jobs,
      icon: 'briefcase',
      label: `Offres d'emploi`,
    },
    {
      link: routes.authenticated.iaAssistant,
      icon: 'magic-wand',
      label: isMentor ? 'Super Mentor IA' : `Services assistés par l'IA`,
      badge: 'NOUVEAU',
    },
    {
      link: routes.authenticated.services,
      icon: 'book',
      label: `Services partenaires`,
    },
    {
      link: routes.authenticated.faq,
      icon: 'question',
      label: `FAQ`,
    },
  ]

  const nqtClubItem: NavMenuItem = {
    link: env.LEVELUP_URL,
    icon: 'news',
    label: 'Club NQT',
  }

  const itemsWithNQTClub = [
    ...baseItems.slice(0, 3),
    nqtClubItem,
    ...baseItems.slice(3, baseItems.length),
  ]

  const getMenuItems = () => {
    if (!isYoung(user)) return itemsWithNQTClub
    else if (user.isAlumni) return itemsWithNQTClub
    return baseItems
  }

  const menuItems = getMenuItems()

  if (isYoung(user)) {
    const matching = matchings?.find((match) => !match.endedSponsorship)
    if (matching && matching.sponsor) {
      menuItems.push({
        link: generatePath(routes.authenticated.sponsor, {
          id: matching.sponsor.id.toString(),
        }),
        icon: 'friendship',
        label: 'Fiche parrain',
      })
    }
  }
  return menuItems
}
